import React, { useMemo } from 'react'
import ReactCountryFlag from 'react-country-flag'
import { createFilter } from 'react-select'
import countryList from '../util/reactSelectCountryList'

const frequentCountries = ['CA', 'GB', 'US']

const useCountrySelectOptions = () => {
  const countryOptions = useMemo(
    () =>
      countryList()
        .getData()
        .map((option) => ({
          value: option.value,
          label: (
            <>
              <ReactCountryFlag
                countryCode={option.value}
                svg
                className="me-2"
                style={{
                  width: '1.5em',
                  height: '1.5em',
                }}
              />
              {option.label}
            </>
          ),
        })),
    [],
  )

  const frequentCountriesFirstOptions = useMemo(
    () => [
      {
        label: null,
        options: countryOptions.filter((option) => frequentCountries.includes(option.value)),
      },
      {
        label: null,
        options: countryOptions.filter((option) => !frequentCountries.includes(option.value)),
      },
    ],
    [countryOptions],
  )

  const countryFilter = useMemo(
    () =>
      createFilter({
        stringify: (option) => countryList().getLabel(option.value),
      }),
    [],
  )

  return {
    countryOptions,
    frequentCountriesFirstOptions,
    countryFilter, // ALWAYS pass this prop to the Select component to be able to search, e.g. filterOption={countryFilter}
  }
}

export default useCountrySelectOptions
